import { useMutation } from '@tanstack/react-query'

import { authApi } from '@/api/authApi'
import { queryClient } from '@/lib/query/queryClient'
import { useAuthStore } from '@/stores/authStore'

export function useLogout() {
  return useMutation({
    mutationFn: () => authApi.logout(),
    // Sign the user out locally even if the server call fails — the cookie is
    // gone or expired either way, and staying "signed in" would be a lie.
    onSettled: () => {
      useAuthStore.getState().clearSession()
      queryClient.clear()
    },
  })
}
